import * as React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {
  Member,
//   MembersDetailsMode,
  MembersState,
//   MembersResponseData,
  MakePaymentRequest
//   ProgramMemberInfo,
//   MemberType,
//   MemberStatusCode
} from './members.types';
import { BusinessState } from '../business/business.types';
import { AuthState } from '../auth/auth.types';
// import { isAdminAccount, isImpersonating } from '../admin/Util';
import { AdminState } from '../admin/admin.types';
import {
  // Schedule,
  ProgramsState,
  // Program 
} from '../programs/Types';
import { PAYMENT } from '../account/Constants';
import { cannotWrite } from '../util/permission.util';
import { IdleState } from '../idle/Types';
// import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
// import * as _ from 'lodash';
import ReactTable from 'react-table';
// import { dateFromString } from '../util/date-util';
// import { getMembershipStatus } from './members.util';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import * as moment from 'moment';
// import { isProgramDisabled } from '../util/permission.util';
import { PaymentMethod } from '../billing/billing.const';
import { 
  DEFAULT_PAYER, 
  defaultPaymentMethodWith, 
  DEFAULT_PAYMENT,
  DEFAULT_MEMBER_ID
} from './members.constants';
import { RIDIRECT_FROM_MEMBER } from '../payments/Constants';
import { EntityStatus } from '../programs/Types';
import { mmsStore } from 'src/app/app.config';

const PAYMENT_START_DAYS = [1, 5, 10, 15, 20, 25];

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly programsState: ProgramsState
  readonly membersState: MembersState
  readonly toAdminDashboard?: () => void
  readonly businessState: BusinessState
  readonly toDashboard?: () => void
  readonly toPaymentList?: () => void
  readonly idleState: IdleState
  readonly isItEditMode: boolean
  readonly isContinuousPayment: boolean
  readonly renderAmountEditable: (cellInfo) => void
  readonly renderChargeDateEditable: (cellInfo) => void
  readonly makePaymentRequestHandler: (r: MakePaymentRequest) => void
  readonly makePaymentRequest?: MakePaymentRequest
  readonly updateScheduledPayment: (
    id: number, 
    chargeDate: number, 
    amount: number
  ) => Promise<Response>
  readonly handleRedirectToPaymentListPage?: Function
};

type States = {
  readonly makePaymentRequest: MakePaymentRequest
  readonly selectedRow: number
  readonly member: Member
  readonly scheduledPaymentsForUpdate: {
    chargeDate: any,
    newChargeDate?: any, 
    amount: string,
    newAmount?: string,
    editableFieldError: string,
    scheduledPaymentId?: number,
    status?: EntityStatus
  }[]
  readonly activePaymentFilter: string
};

class PaymentTableComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      makePaymentRequest: {
        id: DEFAULT_PAYMENT.id,
        newPaymentInfo: DEFAULT_PAYMENT, 
        downPayment: 0, 
        total: 0, 
        amountPerTransaction: 0, 
        startDate: new Date().getTime(), 
        payerId: DEFAULT_PAYER.id, 
        memberId: props.membersState.member.id, 
        paymentMethodId: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE).id, 
        continuous: false, 
        schedules: [],
        // Only for display
        amountPerTransactionError: '',
        paymentError: {
          numOfTransactionError: ''
        },
        downPaymentError: '',
        newPayer: DEFAULT_PAYER,
        newPayMethod: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE),
        paymentStartDate: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: PAYMENT_START_DAYS.includes(new Date().getDate()) ?
            new Date().getDate() :
            1
        },
        downPaymentString: '0.00',
        amountPerTransactionString: '0.00',
        totalString: '0.00',
        // Not a clean way. This is used in member create/update request.
        newScheduledPayments: []
      },
      selectedRow: null,
      member: props.membersState.member,
      scheduledPaymentsForUpdate: [],
      activePaymentFilter: 'All'
    };
  }

  // componentDidMount() {
    
  // }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps) {

      this.setState((prevState) => ({ 
        member: nextProps.membersState.member,
      }));

      if (!nextProps.membersState.paymentsTableRowClicked) {
        this.setState({ scheduledPaymentsForUpdate: [] });
      }

      if (
        this.props.makePaymentRequest !== nextProps.makePaymentRequest &&
        !nextProps.makePaymentRequest &&
        this.state.makePaymentRequest.newPayer.id !== DEFAULT_PAYER.id &&
        this.state.makePaymentRequest.newPayMethod.id !== defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE).id
      ) {
        this.setState({
          makePaymentRequest: {
            id: DEFAULT_PAYMENT.id,
            newPaymentInfo: DEFAULT_PAYMENT, 
            downPayment: 0, 
            total: 0, 
            amountPerTransaction: 0, 
            startDate: new Date().getTime(), 
            payerId: DEFAULT_PAYER.id, 
            memberId: nextProps.membersState.member.id, 
            paymentMethodId: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE).id, 
            continuous: true, 
            schedules: [],
            // Only for display
            amountPerTransactionError: '',
            paymentError: {
              numOfTransactionError: ''
            },
            downPaymentError: '',
            newPayer: DEFAULT_PAYER,
            newPayMethod: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE),
            paymentStartDate: {
              year: new Date().getFullYear(),
              month: new Date().getMonth() + 1,
              day: PAYMENT_START_DAYS.includes(new Date().getDate()) ?
                new Date().getDate() :
                1
            },
            downPaymentString: '0.00',
            amountPerTransactionString: '0.00',
            totalString: '0.00',
            // Not a clean way. This is used in member create/update request.
            newScheduledPayments: []
          }
        });
      }

    }
  }

  componentWillUnmount() {
    this.setState({
      selectedRow: null,
      makePaymentRequest: {
        id: DEFAULT_PAYMENT.id,
        newPaymentInfo: DEFAULT_PAYMENT, 
        downPayment: 0, 
        total: 0, 
        amountPerTransaction: 0, 
        startDate: new Date().getTime(), 
        payerId: DEFAULT_PAYER.id, 
        memberId: DEFAULT_MEMBER_ID, 
        paymentMethodId: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE).id, 
        continuous: true, 
        schedules: [],
        // Only for display
        amountPerTransactionError: '',
        paymentError: {
          numOfTransactionError: ''
        },
        downPaymentError: '',
        newPayer: DEFAULT_PAYER,
        newPayMethod: defaultPaymentMethodWith(PaymentMethod.VOIDCHEQUE),
        paymentStartDate: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: PAYMENT_START_DAYS.includes(new Date().getDate()) ?
            new Date().getDate() :
            1
        },
        downPaymentString: '0.00',
        amountPerTransactionString: '0.00',
        totalString: '0.00',
        // Not a clean way. This is used in member create/update request.
        newScheduledPayments: []
      },
      activePaymentFilter: 'All'
    });
  }

  render() {
    const { authState, adminState, membersState, handleRedirectToPaymentListPage } = this.props;
    const { member } = this.state;

    return(
      <div className="row">
        <div className="col-12">
          <SelectField
            floatingLabelText="Filter By Active"
            value={this.state.activePaymentFilter}
            onChange={this.handleActivePaymentChange}
          >
            <MenuItem value={'All'} primaryText={'All'} />
            <MenuItem value={'Active'} primaryText={'Active'} />
            <MenuItem value={'Inactive'} primaryText={'Inactive'} />
          </SelectField>
          <RaisedButton
            className="float-right"
            style={{bottom: '0px'}}
            label={cannotWrite(PAYMENT, authState, adminState) ? 'Not Enough Permission' : '+ New'}
            primary={true}
            disabled={cannotWrite(PAYMENT, authState, adminState)}
            onClick={() => {
              mmsStore.dispatch({
                type: RIDIRECT_FROM_MEMBER, 
                payload: {
                  body: {
                    entity: { memberId: membersState.member.id }
                  }
                }
              });
              handleRedirectToPaymentListPage(false);
            }}
          />
        </div>
        <div className="col-12">
          <ReactTable
            data={this.state.member ? this.createTableData(this.state.member) : []}
            columns={[
              {
                Header: 'Payer Name',
                accessor: 'payerName',
                style: {textAlign: 'center'}
              },
              {
                Header: 'Payment Method Type',
                accessor: 'paymentMethodType',
                style: {textAlign: 'center'}
              },
              {
                Header: 'Description',
                accessor: 'description',
                style: {textAlign: 'center'}
              },
              {
                Header: 'Start Date',
                accessor: 'startDate',
                style: {textAlign: 'center'}
              },
              {
                Header: 'Active',
                accessor: 'active',
                style: {textAlign: 'center'}
              }
            ]}
            defaultPageSize={20}
            className="-striped -highlight"
            getTdProps={(state, rowInfo, column, instance) => {
              return {
                onClick: (e, handleOriginal) => rowInfo ? this.handleCellClick(rowInfo.index) : null
              };
            }}
          />
        </div>
      </ div> 
    );
  }

  private handleActivePaymentChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ activePaymentFilter: value})

  private handleCellClick = (index) => {
    const { handleRedirectToPaymentListPage, membersState } = this.props;

    mmsStore.dispatch({
      type: RIDIRECT_FROM_MEMBER,
      payload: {
        body: {
          entity: {
            memberId: membersState.member.id,
            paymentId: membersState.member.payments[index].id,
            payerId: membersState.member.payments[index].payer.id,
            paymentMethodId: membersState.member.payments[index].paymentMethod.id
          }
        }
      }
    });
    handleRedirectToPaymentListPage(false);

    this.setState((prevState) => ({
      activePaymentFilter: 'All',
      selectedRow: index,
      scheduledPaymentsForUpdate: prevState.scheduledPaymentsForUpdate.length > 0 ?
        prevState.scheduledPaymentsForUpdate :
        this.props.membersState.member.payments[index].scheduleDetails ? 
          prevState.member.payments[index].scheduleDetails.map(s => {
            return {
              scheduledPaymentId: s.scheduledPaymentId,
              chargeDate: moment(new Date(s.chargeDate)), 
              amount: `${s.amount}`, 
              editableFieldError: ''
            };
          }) :
          []
    }));
  }

  private createTableData = (member) => {
    return member.payments
      .filter(p => p && p.id !== DEFAULT_PAYMENT.id && 
        (
          this.state.activePaymentFilter === 'All' || 
          p.active === (this.state.activePaymentFilter === 'Active')
        )
      )
      .map(p => {
        return {
          payerName: p.payer.firstName + ' ' + p.payer.lastName,
          paymentMethodType: p.paymentMethod.paymentMethodType,
          description: p.description ? p.description : '',
          startDate: moment(new Date(p.startDate)).format('MMM Do YY'),
          active: p.active ? 'YES' : 'NO'
        };
      });
  }
}

export default PaymentTableComponent;



// WEBPACK FOOTER //
// ./src/members/PaymentTableComponent.tsx